module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_4.8dff1b090f4ff9bf845d8ab4959b8ea8.png";